export default __webpack_public_path__ + "static/media/cnh.cd2a983d.png";